import { THEME } from '../../core/constants'

import { DEFINE, QC, QQA } from '../constants'

const getTaskActionButtonColors = currentViewType => {
  switch (currentViewType) {
    case DEFINE:
      return {
        saveButtonColor: THEME.colors.taskViewDefine,
        doneButtonColor: THEME.colors.taskViewDefine,
      }
    case QC:
      return {
        saveButtonColor: THEME.colors.taskViewQc,
        doneButtonColor: THEME.colors.taskViewQc,
      }
    case QQA:
      return {
        saveButtonColor: THEME.colors.taskViewQqa,
        doneButtonColor: THEME.colors.taskViewQqa,
      }
    default:
      return {
        saveButtonColor: undefined,
        doneButtonColor: undefined,
      }
  }
}

export default getTaskActionButtonColors
